"use strict";
// Copyright (C) 2017-2025 Smart code 203358507
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useProfile_1 = __importDefault(require("./useProfile"));
var core_1 = require("stremio/core");
var useSettings = function () {
    var core = (0, core_1.useCore)();
    var profile = (0, useProfile_1.default)();
    var updateSettings = (0, react_1.useCallback)(function (settings) {
        core.transport.dispatch({
            action: 'Ctx',
            args: {
                action: 'UpdateSettings',
                args: __assign(__assign({}, profile.settings), settings)
            }
        });
    }, [profile.settings]);
    return [profile.settings, updateSettings];
};
exports.default = useSettings;
